export const HOME_CATALOG_SECTIONS = [
	'en_edicion',
	'revision',
	'negociacion',
	'en_ejecucion',
]

const hasVisibleProducts = (catalog) => {
	const skuCount = Number(catalog?.sku_count)
	return Number.isFinite(skuCount) && skuCount > 0
}

export const normalizeHomeCatalogs = (catalogs = {}) => {
	const normalized = {...catalogs}

	HOME_CATALOG_SECTIONS.forEach((section) => {
		const sectionCatalogs = Array.isArray(catalogs?.[section])
			? catalogs[section]
			: []

		normalized[section] = sectionCatalogs
			.filter(hasVisibleProducts)
			.sort((a, b) => Number(b.id_promo) - Number(a.id_promo))
	})

	return normalized
}
